import { Component } from "react";
import { Link } from "react-router-dom";
import { shipError } from "../../lib/logger";

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) { return { error }; }

  componentDidCatch(error, info) {
    shipError(error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-8 bg-[#0A0A0A]" data-testid="error-boundary">
        <div className="max-w-xl border border-white/10 bg-[#121215] p-10">
          <div className="text-xs uppercase tracking-[0.3em] text-gold mb-4">Something went wrong</div>
          <h2 className="font-display text-3xl mb-4">We hit an unexpected error.</h2>
          <p className="text-white/65 text-sm leading-relaxed mb-6">
            The page failed to render. Refresh, or return home — our team has been notified.
          </p>
          <div className="flex gap-3">
            <button onClick={() => window.location.reload()} className="btn-primary text-sm">Refresh</button>
            <Link to="/" className="btn-ghost text-sm">Home</Link>
          </div>
        </div>
      </div>
    );
  }
}
